import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Typography } from '@material-ui/core';
import { SearchConfig } from '../../utils/constants';
import { HelperConfigType } from './index';

interface Props {
  minChars?: number;
  maxChars?: number;
  config: HelperConfigType
}

export const HelperText: React.FC<Props> = ({minChars, maxChars, config}: Props): JSX.Element => {
  minChars = minChars || SearchConfig.MinCharsRequired;
  maxChars = maxChars || SearchConfig.MaxCharsAllowed;
  const [t] = useTranslation();
  return (
    <Card elevation={1} square component="span">
      <Typography variant="body1" component="span" noWrap>
        {
          config === 'invalid' ? t('app_search.app_search_help_text', {
            min: minChars,
            max: maxChars
          }) : t('app_search.no_results')
        }
      </Typography>
    </Card>
  );
};
